var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"captcha-img",style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"src":_vm.img,"title":"看不清？点击图片更换"},on:{"click":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }